module.exports = __webpack_public_path__ + "static/media/python.26c488dd.svg";